import * as React from "react";
import { ModelState } from "../../../Models/ModelStateEnum";
import EightWingsUnserviceableCreate from "./EightWingsUnserviceableCreate";
import EightWingsUnserviceableUpdate from "./EightWingsUnserviceableUpdate";

const EightWingsUnserviceable = props => {
  const [tabType, setTabType] = React.useState(ModelState.Create);
  React.useEffect(() => {
    var tempTabType = props?.requestUnserviceableData === null ? ModelState.Create : ModelState.Edit;
    setTabType(tempTabType);
  }, [props?.requestUnserviceableData]);
  switch (tabType) {
    case ModelState.Create:
      return (
        <EightWingsUnserviceableCreate
          requestId={props.requestId}
          eightWingsId={props?.eightWingsId}
          requestDetail={props?.requestDetailData}
          finalCallBack={props.parentCallBack}
        />
      );
    case ModelState.Edit:
      return (
        <EightWingsUnserviceableUpdate
          requestId={props.requestId}
          eightWingsId={props?.eightWingsId}
          requestDetail={props?.requestDetailData}
          unserviceable={props.requestUnserviceableData}
          finalCallBack={props.parentCallBack}
        />
      );
    default:
      return <>Not found</>;
  }
};

export default EightWingsUnserviceable;
